"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
class OptionsMasques extends webix_jet_1.JetView {
    // view : "window",
    // height : 2000,
    // width : 1000,
    // template:"Page de statistiques de gestion",
    // css:"webix_shadow_medium app_start",
    // body : {
    config() {
        return {
            view: "form", id: "mes",
            height: 1485,
            width: 1050,
            elements: [{
                    view: "textarea", name: "masque", label: (0, globals_1._)("Masque"),
                    width: "800", height: 400, id: "blabla",
                    editor: "text"
                }, {
                    view: "text", name: "nom", label: (0, globals_1._)("Nom"),
                    width: "300", attributes: { maxlength: 24 },
                    editor: "text"
                }, {
                    view: "button", css: "app_menu", layout: "x", select: true, id: "fenButton",
                    value: (0, globals_1._)("Enregistrer"), maxWidth: 120,
                    click: () => this.save()
                }, {
                    view: "button", css: "app_menu", layout: "x", select: true, id: "dimButton",
                    value: (0, globals_1._)("Relire"), maxWidth: 120,
                    click: () => this.read()
                }
            ],
        };
    }
    save() {
        // @ts-ignore
        let vv = ($$("blabla").getValue());
        let xx = { "cle": "clients.form", "texte": vv };
        // @ts-ignore
        let promise = webix.ajax().post(globals_1.phpPath + "parametres.php?option=savejson", xx);
        promise.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            webix.message("Données enregistrées");
        });
    }
    read() {
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "parametres.php?key=clients.form&option=readjson");
        promise.then(function (result) {
            // @ts-ignore
            $$("blabla").setValue(JSON.stringify(result.json(), undefined, 4));
            // webix.message(result.json());
        });
    }
    // fen() {
    // 	let fen = new Fenetre();
    // 	// let fen = this.ui(Fenetre);
    // 	fen.show();
    // }
    ready() {
        // debugger;
        // let fen = this.ui(Fenetre);
        // fen.show();
        // $$("mes").load(phpPath + "utilisateurs.php?option=mydata");
    }
}
exports.default = OptionsMasques;
;
